import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { getCountryCode } from "../utils/utils";
import GTMConfig from "../configs/gtmConfig.json";

export const useTagManager = (brandName) => {
  const countryCode = getCountryCode();
  brandName = brandName?.replace(/-/g, "_") ?? brandName;

  useEffect(() => {
    const config = GTMConfig[brandName];
    if (!config) return;

    const gtm =
      config.find((x) => x.country === countryCode) ||
      config.find((x) => x.country === "*");
    if (!gtm) return;

    TagManager.initialize({ gtmId: gtm.gtmId });
  }, [brandName, countryCode]);

  return TagManager;
};
